var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnicoLrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_92433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.26303 539.602H853.392V661.779L780.203 613.404L673.86 658.677L566.263 613.403L473.057 699.61L372.341 728.14L327.927 691.548L292.896 638.831L259.741 670.462L185.925 609.062L134.63 616.505L77.079 567.509L2.63867 548.904L3.26303 539.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 539.602V540.203H852.787V660.655L780.267 612.722L673.859 658.023L566.139 612.697L472.75 699.071L372.483 727.474L328.385 691.142L293.001 637.896L259.714 669.653L186.108 608.428L134.816 615.869L77.3663 566.961L3.27796 548.443L3.86903 539.642L3.26384 539.602V540.203V539.602L2.65865 539.562L2 549.364L76.7934 568.058L134.445 617.14L185.745 609.697L259.769 671.27L292.792 639.767L327.47 691.953L372.201 728.805L473.364 700.148L566.39 614.109L673.861 659.331L780.141 614.085L854 662.903V539H2.69597L2.65865 539.562L3.26384 539.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 539.602V540.203H852.787V660.655L780.267 612.722L673.859 658.023L566.139 612.697L472.75 699.071L372.483 727.474L328.385 691.142L293.001 637.896L259.714 669.653L186.108 608.428L134.816 615.869L77.3663 566.961L3.27796 548.443L3.86903 539.642L3.26384 539.602ZM3.26384 539.602V540.203V539.602ZM3.26384 539.602L2.65865 539.562L2 549.364L76.7934 568.058L134.445 617.14L185.745 609.697L259.769 671.27L292.792 639.767L327.47 691.953L372.201 728.805L473.364 700.148L566.39 614.109L673.861 659.331L780.141 614.085L854 662.903V539H2.69597L2.65865 539.562L3.26384 539.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.039 273H502.809V266.13H496.039V229.5H525.039V273Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.039 234.21V246.43C496.039 246.43 503.039 247 505.039 249C506.051 250.049 507.338 250.793 508.752 251.147C510.167 251.501 511.652 251.45 513.039 251C516.039 250 512.289 247.11 512.289 247.11C512.289 247.11 509.039 249.04 507.039 247.02C505.039 245 503.039 242.02 508.039 239.02C513.039 236.02 517.039 241.02 517.039 241.02C517.039 241.02 531.039 230.02 524.039 229.02C517.039 228.02 513.039 226.02 506.039 230.02C499.039 234.02 496.039 234.21 496.039 234.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.039 122H525.039V369H538.039V122Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.699 191C537.699 191 536.699 164 533.699 162C530.699 160 526.699 165 526.699 170C526.699 175 526.379 191 526.379 191H537.699Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.039 500H499.039V504H563.039V500Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.039 498H518.039V500H522.039V498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.039 498H543.039V500H547.039V498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.039 497H526.039V500H538.039V497Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.039 480H523.039V497H541.039V480Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.039 478H521.039V480H543.039V478Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.039 476H522.039V477H542.039V476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.039 473H521.039V475H543.039V473Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.039 463H527.039V473H537.039V463Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.039 457H529.039V463H535.039V457Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.039 369H500.039V372H560.039V369Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.039 182H530.039V302H533.039V182Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.039 289H524.039V343H506.449C504.749 343 503.119 342.325 501.917 341.123C500.714 339.92 500.039 338.29 500.039 336.59V289Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.039 273H512.039V289H525.039V273Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.039 266H496.039V270H503.039V266Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.039 265.05L519.709 263.99C516.786 263.411 513.758 263.689 510.989 264.79L505.419 267H499.539V247.5H502.539L511.039 255L525.039 260.18V265.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.039 250H507.039V260H525.039V250Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.039 226H500.039V229H509.039V226Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.039 223H509.039V224H512.039V223Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.039 223H520.039V224H523.039V223Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.039 181H528.039V191H536.039V181Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.699 108H534.409C535.905 108 537.339 108.594 538.397 109.652C539.455 110.71 540.049 112.144 540.049 113.64V122H523.049V113.64C523.049 112.899 523.195 112.164 523.479 111.479C523.763 110.794 524.18 110.172 524.704 109.648C525.229 109.125 525.852 108.709 526.537 108.426C527.223 108.144 527.957 107.999 528.699 108Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.039 172H530.039V181H534.039V172Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.039 166H531.039V172H533.039V166Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.039 175H528.039V178H530.039V175Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.039 273H512.039V280H525.039V273Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.039 273H510.039V275H512.039V273Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.039 276H511.039V278H512.039V276Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.039 301H497.039V336H500.039V301Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.039 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.869 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.699 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.539 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.369 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.199 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.039 335V302V335Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.039 312H500.039V324H506.039V312Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.039 291H500.039V296H507.039V291Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.039 372H530.039V457H534.039V372Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.039 486H513.039V492H515.039V486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.039 372H505.039V500H512.039V372Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.039 372H502.039V539H504.039V372Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.039 372H549.039V500H556.039V372Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.039 486H518.039V492H521.039V486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.039 487H515.039V490H518.039V487Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.539 535V506.5H544.539V535.56L519.539 535Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.039 532.4V527H626.539V532.5L549.039 532.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.039 533.36V526H597.539V533.5L585.039 533.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.039 509.22V495H646.539V509.5L641.039 509.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.539 491.4V486H660.539V491.5L544.539 491.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.039 492.36V485H615.539V492.5L603.039 492.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.539 492.36V485H651.539V492.5L636.539 492.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.539 492.36V485H576.539V492.5L565.539 492.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.039 533.36V526H548.539V533.5L545.039 533.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.039 493.32V484H544.539V493.5L541.039 493.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.039 493.32V484H522.539V493.5L521.039 493.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.039 533.36V526H628.539V533.5L626.039 533.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.369 511H639.539V508.5H648.539L648.369 511Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.369 495H639.539V492.5H648.539L648.369 495Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.519 551.51H517.639V628.68H546.519V551.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.818 628.72L524.048 628.95V663.82L528.848 665.82L529.328 664.98L535.078 665.22L535.678 665.7L539.508 664.03L539.868 663.31L540.218 628.78H546.318V709.7H517.848V628.7L517.818 628.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.75 628.94H522.64V664.08L532.02 666.56L541.64 663.29V628.91H546.3V709.82H517.8L517.75 628.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.77 557.3V709.81H546.34V551.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.77 557.3V709.81H546.34V551.81",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.639 562.8V690.85V562.8Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.639 562.8V690.85",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.79 690.62L490.67 693.62L517.79 695.62V690.54V690.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.79 701.5L490.67 704.5L517.79 706.5V701.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.43 701.5L573.54 704.5L546.43 706.5V701.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.43 690.62L573.54 693.62L546.43 695.62V690.54V690.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.87 540.98H516.43V542.5H517.87V540.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.71 540.98H527.27V542.5H528.71V540.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.02 540.98H535.58V542.5H537.02V540.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.12 540.98H546.68V542.5H548.12V540.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.2 534.03H546.76V535.55H548.2V534.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.1 534.03H535.66V535.55H537.1V534.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.71 533.95H527.27V535.47H528.71V533.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.95 534.12H516.51V535.64H517.95V534.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.789 535.5L515.859 541H548.339V535.5H515.789Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.76 538.24L548.41 538.31L515.76 538.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.76 538.24L548.41 538.31",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.86 541.08H546.36L546.3 551.8L517.83 557.3V541.08H517.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.619 556.41V566.91L541.679 562.8V552.67L522.619 556.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.479 565.68V594.5L532.099 588.91L535.459 591.32V564.2L528.459 565.68H528.479Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.648 566.85V691.01V566.85Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.648 566.85V691.01",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.699 690.94V686.06H524.009V604.68H522.639",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.699 690.94V686.06H524.009V604.68H522.639",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.189 598.62L534.839 601.27V628.89H535.729V635.89H528.469V628.89H529.399V602.39L532.189 598.67V598.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.039 679.29H528.849H524.039Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.039 679.29H528.849",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.639 604.7H540.199V686.07H535.539V690.79",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.639 604.7H540.199V686.07H535.539V690.79",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.798 636.99L524.648 640.67V664.06L528.648 665.76",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.798 636.99L524.648 640.67V664.06L528.648 665.76",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.539 636.99L539.689 640.67V664.06L535.689 665.76",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.539 636.99L539.689 640.67V664.06L535.689 665.76",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.469 654.14L539.669 655.52L535.469 654.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.469 654.14L539.669 655.52",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.289 679.29H540.099H535.289Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.289 679.29H540.099",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.819 654.14L524.629 655.5L528.819 654.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.819 654.14L524.629 655.5",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.79 507.59H546.35V509.11H547.79V507.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.69 507.59H535.25V509.11H536.69V507.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.299 507.67H526.859V509.19H528.299V507.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.54 507.5H516.1V509.02H517.54V507.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.379 507.68L515.439 502.18H547.929V507.68H515.379Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.34 504.9L547.99 504.84L515.34 504.9Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.34 504.9L547.99 504.84",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.819 480.77C576.027 480.77 580.249 476.548 580.249 471.34C580.249 466.132 576.027 461.91 570.819 461.91C565.611 461.91 561.389 466.132 561.389 471.34C561.389 476.548 565.611 480.77 570.819 480.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.86 479.94C575.609 479.94 579.46 476.09 579.46 471.34C579.46 466.59 575.609 462.74 570.86 462.74C566.11 462.74 562.26 466.59 562.26 471.34C562.26 476.09 566.11 479.94 570.86 479.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.969 476.8L565.759 475.49L563.969 476.8Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.969 476.8L565.759 475.49",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.419 476.67L575.799 475.5L577.419 476.67Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.419 476.67L575.799 475.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.979 470.99H579.289H577.979Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.979 470.99H579.289",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.738 469.25L563.918 469.47L562.738 469.25Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.738 469.25L563.918 469.47",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.92 466.5L564.92 467.38L563.92 466.5Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.92 466.5L564.92 467.38",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.799 464.4L566.589 465.62L565.799 464.4Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.799 464.4L566.589 465.62",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 463.22L568.73 464.71L568.25 463.22Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 463.22L568.73 464.71",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.949 462.83V464.36V462.83Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.949 462.83V464.36",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.539 463.13L572.979 464.49L573.539 463.13Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.539 463.13L572.979 464.49",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.93 464.18L575.01 465.32L575.93 464.18Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.93 464.18L575.01 465.32",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.629 466.23L576.719 466.93L577.629 466.23Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.629 466.23L576.719 466.93",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.9 468.55L577.85 469.03L578.9 468.55Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.9 468.55L577.85 469.03",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.14 473.7L562.92 474.27L564.14 473.7Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.14 473.7L562.92 474.27",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.91 471.08L574.05 465.67L570.91 471.08Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.91 471.08L574.05 465.67",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.909 472.61C571.583 472.61 572.129 472.064 572.129 471.39C572.129 470.716 571.583 470.17 570.909 470.17C570.236 470.17 569.689 470.716 569.689 471.39C569.689 472.064 570.236 472.61 570.909 472.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.76 473.44L578.86 473.83L577.76 473.44Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.76 473.44L578.86 473.83",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.539 471.6H563.669H562.539Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.539 471.6H563.669",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.66 532.5H635.06C636.088 532.505 637.113 532.405 638.12 532.2C641.33 531.55 647.04 529 647.04 523V511.35H641.04V521.04C641.057 521.981 640.742 522.898 640.15 523.63C639.22 524.75 637.36 526 633.68 526H629.68L629.66 532.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.039 302C526.039 302 527.039 329 530.039 331C533.039 333 537.039 328 537.039 323C537.039 318 537.369 302 537.369 302H526.039Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.039 225V251.92H508.539V225H526.039V226C514.039 229 511.039 231 512.039 237C512.199 238 510.629 244.39 513.039 246C516.039 248 524.039 249 525.039 246C526.119 242.76 529.619 240.42 530.039 240C532.039 238 535.039 232 537.039 232C539.039 232 540.909 225 540.909 225H545.039Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.539 230H519.539V231H521.539V230Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.039 235.5V237.5H527.039V235.5H526.039Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.039 235.5V237.5H515.039V235.5H514.039Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.539 242H519.539V243H521.539V242Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.539 242C523.577 242 526.039 239.538 526.039 236.5C526.039 233.462 523.577 231 520.539 231C517.501 231 515.039 233.462 515.039 236.5C515.039 239.538 517.501 242 520.539 242Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.133 239.756L523.719 241.17L524.426 241.877L525.84 240.463L525.133 239.756Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.651 231.266L515.236 232.68L515.943 233.387L517.358 231.973L516.651 231.266Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.84 232.678L524.426 231.263L523.719 231.971L525.133 233.385L525.84 232.678Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.358 241.168L515.943 239.753L515.236 240.461L516.65 241.875L517.358 241.168Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.039 174.58H534.289V179H536.039V174.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.54 343V361.4C518.617 362.014 518.554 362.637 518.357 363.223C518.159 363.81 517.832 364.344 517.4 364.786C516.967 365.228 516.44 365.567 515.858 365.777C515.277 365.987 514.655 366.064 514.04 366H508.04C507.643 365.992 507.25 366.064 506.882 366.212C506.514 366.36 506.18 366.58 505.9 366.86C505.62 367.141 505.399 367.475 505.251 367.842C505.104 368.21 505.032 368.604 505.04 369",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.359 488.5H618.519H609.359Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.359 488.5H618.519",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.089 489.86C609.763 489.86 610.309 489.314 610.309 488.64C610.309 487.966 609.763 487.42 609.089 487.42C608.415 487.42 607.869 487.966 607.869 488.64C607.869 489.314 608.415 489.86 609.089 489.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.359 529.5H599.529H591.359Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.359 529.5H599.529",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.089 530.86C591.763 530.86 592.309 530.314 592.309 529.64C592.309 528.966 591.763 528.42 591.089 528.42C590.415 528.42 589.869 528.966 589.869 529.64C589.869 530.314 590.415 530.86 591.089 530.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.009 288.235L156.004 290.105L199.044 290.226L199.049 288.356L156.009 288.235Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.488 276.52V344.98H162.108V276.52H159.488Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.54 536.73L124.42 442.17H116.93V536.66L124.55 536.74L124.54 536.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.539 536.58H159.409V442.17L157.529 442.02L157.539 536.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54 536.73L154.4 442.17H145.93V536.66L154.55 536.74L154.54 536.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53 345.36H99V442.25H174.53V345.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34 348.81H101.26V396.09H147.34V348.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64 381.68C115.64 382.337 115.445 382.979 115.08 383.525C114.716 384.07 114.197 384.496 113.591 384.747C112.984 384.999 112.316 385.064 111.672 384.936C111.028 384.808 110.437 384.492 109.972 384.028C109.508 383.563 109.192 382.972 109.064 382.328C108.936 381.684 109.001 381.016 109.253 380.409C109.504 379.803 109.93 379.284 110.476 378.92C111.021 378.555 111.663 378.36 112.32 378.36C113.201 378.36 114.045 378.71 114.668 379.332C115.29 379.955 115.64 380.799 115.64 381.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65 381.68C127.65 382.337 127.455 382.979 127.09 383.525C126.725 384.07 126.207 384.496 125.6 384.747C124.994 384.999 124.326 385.064 123.682 384.936C123.038 384.808 122.446 384.492 121.982 384.028C121.518 383.563 121.202 382.972 121.074 382.328C120.945 381.684 121.011 381.016 121.262 380.409C121.514 379.803 121.939 379.284 122.485 378.92C123.031 378.555 123.673 378.36 124.33 378.36C125.21 378.36 126.055 378.71 126.677 379.332C127.3 379.955 127.65 380.799 127.65 381.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 390.25C108.542 390.6 108.44 390.944 108.247 391.236C108.053 391.528 107.778 391.757 107.454 391.892C107.131 392.028 106.775 392.064 106.431 391.997C106.087 391.93 105.771 391.762 105.522 391.515C105.273 391.268 105.104 390.953 105.035 390.609C104.966 390.265 105 389.909 105.134 389.585C105.267 389.261 105.494 388.984 105.786 388.789C106.077 388.594 106.419 388.49 106.77 388.49C107.238 388.49 107.686 388.675 108.018 389.005C108.35 389.335 108.537 389.782 108.54 390.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54 390.25C115.542 390.6 115.44 390.944 115.247 391.236C115.053 391.528 114.778 391.757 114.454 391.892C114.131 392.028 113.775 392.064 113.431 391.997C113.087 391.93 112.771 391.762 112.522 391.515C112.273 391.268 112.104 390.953 112.035 390.609C111.966 390.265 112 389.909 112.134 389.585C112.267 389.261 112.494 388.984 112.786 388.789C113.077 388.594 113.419 388.49 113.77 388.49C114.238 388.49 114.686 388.675 115.018 389.005C115.35 389.335 115.537 389.782 115.54 390.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54 390.25C122.542 390.6 122.44 390.944 122.247 391.236C122.053 391.528 121.778 391.757 121.454 391.892C121.131 392.028 120.775 392.064 120.431 391.997C120.087 391.93 119.771 391.762 119.522 391.515C119.273 391.268 119.104 390.953 119.035 390.609C118.966 390.265 119 389.909 119.134 389.585C119.267 389.261 119.494 388.984 119.786 388.789C120.077 388.594 120.419 388.49 120.77 388.49C121.238 388.49 121.686 388.675 122.018 389.005C122.35 389.335 122.537 389.782 122.54 390.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54 390.25C129.542 390.6 129.44 390.944 129.247 391.236C129.053 391.528 128.778 391.757 128.454 391.892C128.131 392.028 127.775 392.064 127.431 391.997C127.087 391.93 126.771 391.762 126.522 391.515C126.273 391.268 126.104 390.953 126.035 390.609C125.966 390.265 126 389.909 126.134 389.585C126.267 389.261 126.494 388.984 126.786 388.789C127.077 388.594 127.419 388.49 127.77 388.49C128.238 388.49 128.686 388.675 129.018 389.005C129.35 389.335 129.537 389.782 129.54 390.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.54 390.25C136.542 390.6 136.44 390.944 136.247 391.236C136.053 391.528 135.778 391.757 135.454 391.892C135.131 392.028 134.775 392.064 134.431 391.997C134.087 391.93 133.771 391.762 133.522 391.515C133.273 391.268 133.104 390.953 133.035 390.609C132.966 390.265 133 389.909 133.134 389.585C133.267 389.261 133.494 388.984 133.786 388.789C134.077 388.594 134.419 388.49 134.77 388.49C135.238 388.49 135.686 388.675 136.018 389.005C136.35 389.335 136.537 389.782 136.54 390.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.54 390.25C143.542 390.6 143.44 390.944 143.247 391.236C143.053 391.528 142.778 391.757 142.454 391.892C142.131 392.028 141.775 392.064 141.431 391.997C141.087 391.93 140.771 391.762 140.522 391.515C140.273 391.268 140.104 390.953 140.035 390.609C139.966 390.265 140 389.909 140.134 389.585C140.267 389.261 140.494 388.984 140.786 388.789C141.077 388.594 141.419 388.49 141.77 388.49C142.238 388.49 142.686 388.675 143.018 389.005C143.35 389.335 143.537 389.782 143.54 390.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.66 381.68C139.66 382.337 139.465 382.979 139.1 383.525C138.735 384.07 138.217 384.496 137.61 384.747C137.003 384.999 136.336 385.064 135.692 384.936C135.048 384.808 134.456 384.492 133.992 384.028C133.528 383.563 133.211 382.972 133.083 382.328C132.955 381.684 133.021 381.016 133.272 380.409C133.524 379.803 133.949 379.284 134.495 378.92C135.041 378.555 135.683 378.36 136.34 378.36C137.22 378.36 138.065 378.71 138.687 379.332C139.31 379.955 139.66 380.799 139.66 381.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66 383.68C163.66 384.337 163.465 384.979 163.1 385.525C162.735 386.07 162.217 386.496 161.61 386.747C161.003 386.999 160.336 387.064 159.692 386.936C159.048 386.808 158.456 386.492 157.992 386.028C157.528 385.563 157.211 384.972 157.083 384.328C156.955 383.684 157.021 383.016 157.272 382.409C157.524 381.803 157.949 381.284 158.495 380.92C159.041 380.555 159.683 380.36 160.34 380.36C161.22 380.36 162.065 380.71 162.687 381.332C163.31 381.955 163.66 382.799 163.66 383.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.539 351.41H140.539C140.675 351.41 140.811 351.438 140.936 351.492C141.061 351.546 141.174 351.625 141.268 351.724C141.362 351.823 141.434 351.941 141.481 352.069C141.527 352.197 141.547 352.334 141.539 352.47V374.19C141.547 374.326 141.527 374.463 141.481 374.591C141.434 374.72 141.362 374.837 141.268 374.936C141.174 375.036 141.061 375.115 140.936 375.169C140.811 375.223 140.675 375.25 140.539 375.25H107.539C107.402 375.25 107.267 375.223 107.142 375.169C107.016 375.115 106.903 375.036 106.81 374.936C106.716 374.837 106.644 374.72 106.597 374.591C106.551 374.463 106.531 374.326 106.539 374.19V352.47C106.531 352.334 106.551 352.197 106.597 352.069C106.644 351.941 106.716 351.823 106.81 351.724C106.903 351.625 107.016 351.546 107.142 351.492C107.267 351.438 107.402 351.41 107.539 351.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.22 353.5H108.09V366.25H140.22V353.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.529 368.25H119.709V369H120.529V368.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.529 368.25H122.709V369H123.529V368.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.529 368.25H125.709V369H126.529V368.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.529 368.25H128.709V369H129.529V368.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.529 370.38H119.709V371.13H120.529V370.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.529 370.38H122.709V371.13H123.529V370.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.529 370.38H125.709V371.13H126.529V370.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.529 370.38H128.709V371.13H129.529V370.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.529 372.5H119.709V373.25H120.529V372.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.529 372.5H122.709V373.25H123.529V372.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.529 372.5H125.709V373.25H126.529V372.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.529 372.5H128.709V373.25H129.529V372.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.04 323.25H166.54C167.2 323.25 167.74 323.47 167.74 323.74V324.74C167.74 325.01 167.2 325.23 166.54 325.23H159.04C158.38 325.23 157.84 325.01 157.84 324.74V323.74C157.84 323.47 158.38 323.25 159.04 323.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.04 295.25H166.54C167.2 295.25 167.74 295.47 167.74 295.74V296.74C167.74 297.01 167.2 297.23 166.54 297.23H159.04C158.38 297.23 157.84 297.01 157.84 296.74V295.74C157.84 295.47 158.38 295.25 159.04 295.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.109 275V303.22",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.01 277.48V300.9",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.949 280.52V298.01",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.779 284.16V295.68",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.379 286.56V292.23",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.619 287.76V291.22",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.659 292.25H171.079C169.875 292.199 168.689 292.551 167.707 293.25C166.725 293.949 166.005 294.956 165.659 296.11C165.049 298.65 164.539 302.88 164.539 309.9V344.48",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33 384V394.25",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.828 480.08H583.818V484.5H587.828V480.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_92433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicoLrp);
export default __webpack_public_path__ + "static/media/unico-lrp.c27f1712e3ccd9fe67a1aac7fd6f6a4d.svg";
export { ForwardRef as ReactComponent };